// src/routes/settingsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';

import GeneralSettings from '../pages/settings/GeneralSettings';
import ContactSettings from '../pages/settings/ContactSettings';
import PaymentSettings from '../pages/settings/PaymentSettings';
import IntegrationsSettings from '../pages/settings/IntegrationsSettings';
import ProtectedRoute from '../components/global/ProtectedRoute';

const settingsRoutes = (
    <>
        <Route
            path="/settings/general"
            element={
                <ProtectedRoute requiredPermission="settings.manage">
                    <GeneralSettings />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/contact"
            element={
                <ProtectedRoute requiredPermission="settings.manage">
                    <ContactSettings />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/payment"
            element={
                <ProtectedRoute requiredPermission="settings.manage">
                    <PaymentSettings />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/integrations"
            element={
                <ProtectedRoute requiredPermission="settings.manage">
                    <IntegrationsSettings />
                </ProtectedRoute>
            }
        />
    </>
);

export default settingsRoutes;
